import en_US from "./locales/en_US.json";

const translations = {
  "en-us": { ...en_US }
};

export default translations;